import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=0e4eda24&scoped=true&"
import script from "./InputTextArea.vue?vue&type=script&lang=js&"
export * from "./InputTextArea.vue?vue&type=script&lang=js&"
import style0 from "./InputTextArea.vue?vue&type=style&index=0&id=0e4eda24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4eda24",
  null
  
)

export default component.exports